import { h, Component, Fragment } from "preact";
import { TicketHeader, TicketBody, EndedTicketPopups } from "../mobile-pages/ticket-ltn.jsx";
import Page from "../../../services/page-data-feed"

import FullSite from "./full-site";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as L from "../desktop-templates/live-general.jsx";
import * as T from "../desktop-templates/prematch-right-col.jsx";
import * as C from "../desktop-templates/cashout.jsx";

import TicketCheckBet from "../desktop-components/ticket-check-bet.jsx";
import TicketLoadBet, { TicketLoadCashier } from "../desktop-components/ticket-load-bet.jsx";

import CashoutComponent from "../desktop-components/cashout.jsx";
import CashoutEnhanced from "../desktop-components/cashout-enhanced.jsx";


export default function Cashout() {
	return <FullSite><CashoutTemplate /></FullSite>;
}

export function CashoutTemplate() {
	return <div class="font-roboto">
		<div class="flex border-b border-b-harifzinc-950 bg-harif-900 text-white">

			<div class="scrollbar-fancy min-w-0 grow overflow-y-scroll border-r border-r-harifzinc-950">
				<L.TopRowContainer>
					<L.ContainerLink>
						<L.TopPageLink href="/live">general view</L.TopPageLink>
						<L.TopPageLink href="/prematch">sport home</L.TopPageLink>
						<L.TopPageLink href="/cashout" active={true}>my bets</L.TopPageLink>
					</L.ContainerLink>
				</L.TopRowContainer>

				<div class="p-4"><CashoutEnhanced /></div>

			</div>
			<div class="scrollbar-fancy w-72 flex-none overflow-y-scroll border-r border-r-harifzinc-950">
				<T.ColumnTicketWrappper>
					<T.TicketTopRow>
						<TicketHeader />
					</T.TicketTopRow>
					<TicketBody />
					<EndedTicketPopups />
				</T.ColumnTicketWrappper>
				<M.BlankSeparator />
				<TicketLoadBet />
				<M.BlankSeparator />
				<TicketCheckBet />
				<M.BlankSeparator />
				<TicketLoadCashier />
			</div>
		</div>
	</div>
}
